columnOffset